import { ReduxState } from 'src/store/types';

export const dataSourceIdsSelector = (state: ReduxState) => {
  return state.dataSources.dataSourceIds;
};
